var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"passage-siblings-widget"},_vm._l((_vm.siblings),function(sibling){return _c('div',{key:sibling.urn,staticClass:"grid-cell-square"},[_c('ReaderLink',{class:{ 'active-sibling': sibling.selected },attrs:{"urn":sibling.urn}},[_vm._v(" "+_vm._s(sibling.lcp)+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }